<template>
  <div class="">
    <com-head :leadtext="toptext"></com-head>
    <div class="menu-key">
      <p class="enter-text">部分代表企业  <span>&nbsp;&nbsp;(内容由企业提供，CPS中安网整理)</span> </p>
      <ul class="entimg">
        <li
          v-for="(list, index) in listimg"
          :class="{ selected: index == isactive }"
          @click="entclick(index)"
        >
          <img :src="list.logo" alt="" />
        </li>
      </ul>
    </div>
    <div class="menu-key">
      <div class="key-content">
        <div class="keycon-title">
          <h3>{{ contitle }}</h3>
          <div class="aa"></div>
        </div>
        <div v-html="content" id="content-style-sch"></div>
      </div>
    </div>
  </div>
</template>

<script>
import comhead from "./comhead.vue";
import { trend } from "../api/api";

export default {
  components: {
    "com-head": comhead,
  },
  data() {
    return {
      isactive: 0, //默认第一个有样式
      toptext:
        "2020年突然而至的疫情，全球市场环境瞬息万变，企业战略发生颠覆性转变，或成或败，仅此一年。企业需运筹帷幄，充分融合企业内生力和外部需求力，做出全局性和长远性的谋划，实现长期的生存和发展。 ",
      antarray: [
        {
          content: "",
          create_time: 0,
          keyword: "",
          title: "",
        },
      ],
      listimg: [
        {
          id: 0,
          image: "",
          pid: 0,
          title: "",
        },
      ],
      contitle: "",
      content: "",
      id: 0,
      // 关键词默认值
      activeName: "0",

      //折叠面板默认值
      activeNames: ["1"],
    };
  },
  methods: {
    //获取数据
    getData: function () {
      var gain = {
        cate_id: 33,
        where: "[year,=,2020]",
        limit: 40,
      };
      trend(gain).then((res) => {
        this.listimg = res.data.list;
        console.log(res.data.list);
        this.entclick(0);
      });
    },
    entclick: function (id) {
      console.log(id);
      this.contitle = this.listimg[id].title;
      this.content = this.listimg[id].content;
      //this.listimg[id].content
      this.isactive = id;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
@import "../assets/public.less";
.menu-key{
  padding: 30px;
}
.selected {
  border: 2px solid !important;
  border-image: linear-gradient(
      270deg,
      rgba(56, 18, 178, 0.5),
      rgba(250, 29, 129, 0.5)
    )
    4 4 !important;
}
.key-content {
  border-top: 0;
  padding: 50px;
}
.menu-key {
  
  margin: 15px 0px;
  background: #ffffff;
}
/deep/.key-content h5 {
  font-family: PingFang SC;
  margin-top: 30px !important;
  text-align: left;
  margin: 30px 0px;
  margin-left: -30px;
}
#content-style-tre {
  color: #666666;
  width: 100%;
  margin-top: 30px;
}
</style>
<style scoped>
/* 表格样式 */
.key-content >>> table {
  width: 100% !important;
  font-size: 12px !important;
}
.key-content >>> table tr {
  height: 41px !important;
  border-top: 1px solid #ececec !important;
  text-align: center !important;
}
.key-content >>> table tr:nth-child(1) td {
  font-size: 18px !important;
  color: #666666 !important;
}
.key-content >>> table tr td {
  font-size: 16px !important;
  color: #666666 !important;
  border-bottom: 1px solid #ececec !important;
}
.key-content >>> table tr td span {
  color: #666666 !important;
}
.key-content >>> table tbody tr:nth-child(1) {
  background: #f9f9fa !important;
  font-weight: bold !important;
  text-align: center !important;
}
</style>


// WEBPACK FOOTER //
// src/components/strategy.vue